import { Query, RestApiKey } from 'graphql/generated/graphqlTypes';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockRestApiKey } from 'mocks/graphqlMocks/restApiKey';

export function mockedGetRestAPIKeysData(getRestApiKeys: RestApiKey[]): Pick<Query, 'getRestApiKeys'> {
  return {
    getRestApiKeys
  };
}
const fieldsToRemoveFromRestApiKey: (keyof RestApiKey)[] = ['tenantId'];

export const mockedGetRestAPIKeysDataForQuery = mockedGetRestAPIKeysData([
  removeFields(
    generateMockRestApiKey({
      id: 'mock-key-1',
      description: 'Mock key 1',
      apiKey: 'abcdef****',
      createdAt: '2011-10-05T14:48:00.000Z'
    }),
    fieldsToRemoveFromRestApiKey
  ),
  removeFields(
    generateMockRestApiKey({
      id: 'mock-key-2',
      description: 'Mock key 2',
      apiKey: 'ghijkl****',
      createdAt: '2024-10-05T14:48:00.000Z'
    }),
    fieldsToRemoveFromRestApiKey
  )
]);
